module.exports = __webpack_public_path__ + "img/rpa_image01.756162da.png";